<template>
  <div class="partner-banner">
    <div class="container">
      <div
        v-if="subHeader"
        class="partner-banner-block"
      >
        <div class="partner-banner-content">
          <h1
            v-html="subHeader.title"
            class="partner-banner-content__title"
          />
          <p class="partner-banner-content__text">
            {{ subHeader.text }}
          </p>
          <ABtn v-if="subHeader.btn" :label="subHeader.btn.title" class="primary" />
        </div>
        <img
          v-if="subHeader.picture"
          v-bind="subHeader.picture"
          class="partner-banner-block__image"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ABtn } from "../../ui";
import { useHeader } from "../../../composables/useHeader";

export default {
  name: 'PartnerBanner',
  props: ['result'],
  components: {
    ABtn,
  },
  setup() {
    const {subHeader} = useHeader();
    return {
      subHeader,
    }
  }
}
</script>

<style lang="scss" scoped>
.partner-banner {
  position: relative;
  background: linear-gradient(1.29deg, #E8EAE9 1.28%, #F8F8F8 99.09%);
  padding-top: 100px;
  @include tablet{
    padding-top: 80px;
  }
  @include mobile{
    padding-top: 55px;
  }
  &:before{
    content: '';
    display: block;
    height: 1px;
    background-color: #E9EBED;
    position: absolute;
    top: 100px;
    width: 100%;
    @include tablet{
      top: 80px;
    }
    @include mobile{
      content: none;
    }
  }
}
.partner-banner-content{
  @include mobile{
    order: 2;
  }
  &__title{
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 74px;
    line-height: 74px;
    color: #000000;
    margin: 0 0 36px;
    @include tablet{
      font-size: 32px;
      line-height: 38px;
      margin: 0 0 16px;
    }
  }
  &__text{
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #000000;
    margin-bottom: 44px;
    @include tablet{
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }
  :deep{
    .a-btn{
      white-space: normal;
    }
  }
}
.partner-banner-block{
  display: grid;
  grid-template-columns: 1fr 653px;
  align-items: center;
  grid-column-gap: 170px;
  grid-row-gap: 17px;
  height: 660px;
  padding-right: 125px;
  @include tablet{
    grid-template-columns: 1fr 364px;
    height: 460px;
    padding-right: 62px;
    grid-column-gap: 66px;
  }
  @include mobile{
    grid-template-columns: 1fr;
    height: unset;
    padding-right: unset;
    padding-bottom: 52px;
  }
  &__image{
    align-self: end;
    @include mobile{
      order: 1;
    }
  }
}
</style>